import { Link as HeroLink } from '@heroui/react';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link, useNavigate } from 'react-router-dom';

import { useCreateBuyerMutationMutation } from '../../../../generated';
import { BuyerForm } from '../BuyerForm';
import type { BuyerFormData } from '../BuyerForm';

export const CreateBuyer: React.FC = () => {
  const navigate = useNavigate();
  const [createBuyer] = useCreateBuyerMutationMutation();

  const handleSubmit = async (data: BuyerFormData) => {
    const response = await createBuyer({
      variables: {
        buyerCreateInput: {
          name: data.name,
          displayName: data.displayName || undefined,
          fullAddress: data.fullAddress,
          deliveryComment: data.deliveryComment || undefined,
          city: data.addressCity || undefined,
          country: data.addressCountry || undefined,
          isTest: data.isTest,
          latitude: data.addressLatitude || undefined,
          longitude: data.addressLongitude || undefined,
          utcOffset: data.addressUTCOffset || undefined,
          addressSource: data.addressSource || 'custom',
          googlePlaceAddressId: data.addressGooglePlaceId || undefined,
        },
      },
    });

    if (response.data?.buyerCreate?.id) {
      navigate(`/buyers/${response.data.buyerCreate.id}`);
    } else {
      navigate('/buyers');
    }
  };

  const handleCancel = () => {
    navigate('/buyers');
  };

  return (
    <>
      <Helmet>
        <title>Create Buyer - Choco Admin</title>
      </Helmet>
      <div className="p-6 min-h-screen bg-background">
        <div className="mb-6">
          <HeroLink
            as={Link}
            to="/buyers"
            color="primary"
            className="inline-flex items-center gap-2 mb-4"
          >
            ← Back to Buyers
          </HeroLink>
          <h1 className="text-3xl font-bold text-foreground mb-2">
            Create New Buyer
          </h1>
          <p className="text-default-600">
            Add a new buyer to the system. Start by searching for their business
            location.
          </p>
        </div>

        <BuyerForm
          mode="create"
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          title="Buyer Information"
        />
      </div>
    </>
  );
};
